import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {updateAnswer, setShowGroup, clearShowGroup} from "../../../actions/answerEditorActions";
import {getActionTemplate} from "../../../actions/actionTemplateActions";
import {getTemplateListCurrent} from "../../../actions/templateListActions";
import {
    setGroupShowGroupKeys,
    addGroupShowGroupKeys
} from "../../../actions/groupEditorActions";
import {
    getGroupTemplate,
    setGroupTemplateShowGroupKeys,
    addGroupTemplateShowGroupKeys
} from "../../../actions/groupTemplateActions";
import {
    addQuestionShowGroupKeys,
    setQuestionEditorShowGroupKeys
} from "../../../actions/questionEditorActions";
import {
    addQuestionTemplateShowGroupKeys,
    setQuestionTemplateShowGroupKeys
} from "../../../actions/questionTemplateActions";
import ArgoMetadataEditorHook from "../../common/ArgoMetadataEditorHook";
import ArgoSelectExistingHook from "../../common/ArgoSelectExistingHook";
import ArgoTextFieldSelectHook from "../../common/ArgoTextFieldSelectHook";
import ArgoAutocompleteHook from "../../common/ArgoAutocompleteHook";
import ArgoIconButtonHook from "../../common/ArgoIconButtonHook";
import ArgoSectionOpenCloseHook from "../../common/ArgoSectionOpenCloseHook";
import ArgoSelectWithRenderValueHook from "../../common/ArgoSelectWithRenderValueHook";
import ArgoTextFieldHook from "../../common/ArgoTextFieldHook";
import ArgoColorInputHook from "../../common/ArgoColorInputHook";
import * as metadataTemplateTypes from "../../../constants/metadataTemplateTypes";
import * as color from "../../../constants/colorConstants";
import * as icon from "../../../constants/iconConstants";
import {
    createEditorOrigin,
    editorOriginMatches,
    EDITOR_TYPES
} from "../../../utilities/editorInstanceOwnership";
import * as TEMPLATE from "../../../constants/templateConstants";
import * as questionTypes from "../../../constants/questionTypeConstants";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities";
import {ALLOWED_TOKEN} from "../../../constants/dataConstants";
import ArgoButtonHook from "../../common/ArgoButtonHook";
import * as Colors from "@mui/material/colors";
import * as portalTypes from "../../../portal/constants/actionConstants";



function AnswerEditorDetails(props) {

    const {
        template,
        index,
        answerOption,
        questionDepth,
        parentSetStateCallback,
        groupTemplateMode = false,
        isLikertAnswer = false,
        displayAsLikert,
        showCustomColor = true,
        setMetadataErrorText: setMetadataErrorTextProp,
        answerOptionTemplates,
        createMode
    } = props;

    const dispatch = useDispatch();

    // Redux state
    const actionTypeList = useSelector(state => state.actionTypeList);
    const groupTemplates = useSelector(state => state.groupTemplate);
    const actionTemplateList = useSelector(state => state.actionTemplateList);
    const actionTemplateState = useSelector(state => state.actionTemplate);
    const isGroupLikertType = groupTemplateMode && isLikertAnswer;
    const questionTemplate = useSelector(state => isGroupLikertType ? null : state.questionEditor[questionDepth]?.template);
    const answerIndex = useSelector(state => state.showGroup.answerIndex);
    const newShowGroupAdded = useSelector(state => state.showGroup.newShowGroupAdded);
    const showGroupOrigin = useSelector(state => state.showGroup.origin);
    const questionEditorState = useSelector(state => state.questionEditor[questionDepth]);
    const groupEditorState = useSelector(state => state.groupEditor);

    // Local state
    const [selectedActionType, setSelectedActionType] = useState(actionTypeList[0] || "");
    const [actionsListBySelectedActionType, setActionsListBySelectedActionType] = useState([]);
    const [selectedActionTemplate, setSelectedActionTemplate] = useState({});
    const [metadataErrorText, setMetadataErrorTextLocal] = useState("");
    const [sectionActionsOpen, setSectionActionsOpen] = useState(false);
    const [sectionShowGroupsOpen, setSectionShowGroupsOpen] = useState(false);
    const [sectionMetadataOpen, setSectionMetadataOpen] = useState(false);
    //const [isThisAnExistingGroup, setIsThisAnExistingGroup] = useState("0");
    const [isThisAnExistingAction, setIsThisAnExistingAction] = useState("0");
    const [iconPosition, setIconPosition] = useState("0");
    const [currentGroupTemplates, setCurrentGroupTemplates] = useState({});
    const [selectedShowGroupKey, setSelectedShowGroupKey] = useState("");

    // componentDidMount equivalent
    useEffect(() => {
        let iconInitObj = icon.initIconSelectEntries(answerOption.metadata, (isLikertAnswer || displayAsLikert));
        setIconPosition(iconInitObj.iconPosition || "0");

        dispatch(getTemplateListCurrent(null, {mode: TEMPLATE.TYPE.ACTION}, TEMPLATE.TYPE.ACTION));
        setCurrentGroupTemplates(groupTemplates);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // componentWillReceiveProps equivalent - handle actionTypeList changes
    useEffect(() => {
        if (actionTypeList.length > 0) {
            buildActionListBySelectedActionType(actionTypeList, actionTemplateList, selectedActionType);
        }
    }, [actionTypeList, actionTemplateList, selectedActionType]);

    // Handle show group additions
    useEffect(() => {
        const parentEditorType = groupTemplateMode ? EDITOR_TYPES.GROUP : EDITOR_TYPES.QUESTION;
        const parentEditorState = groupTemplateMode ? groupEditorState : questionEditorState;
        const parentDepth = groupTemplateMode ? 0 : questionDepth;
        if (newShowGroupAdded
            && answerIndex === index
            && editorOriginMatches(showGroupOrigin, parentEditorType, parentEditorState, parentDepth)) {
            for (const [key, value] of Object.entries(groupTemplates)) {
                if (!currentGroupTemplates.hasOwnProperty(key)) {
                    addGroupToAnswer(value, groupTemplates);
                    setCurrentGroupTemplates(groupTemplates);
                    dispatch(clearShowGroup(false, null, showGroupOrigin));
                }
            }
        }
    }, [newShowGroupAdded, groupTemplates]); // eslint-disable-line react-hooks/exhaustive-deps

    // Update icon state when answerOption changes
    useEffect(() => {
        let iconInit = icon.initIconSelectEntries(answerOption.metadata, (isLikertAnswer || displayAsLikert));
        setIconPosition(iconInit.iconPosition || "0");
        
        loadActions();
        validateAnswerOptions(answerOption, answerOptionTemplates);
    }, [answerOption, answerOptionTemplates]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        //debugger; // SSSSS Show Group Testing
        if (groupTemplates && groupTemplates.hasOwnProperty(selectedShowGroupKey)) {
            let tempArray = []
            tempArray.push(selectedShowGroupKey);

            if (groupTemplateMode) {
                //debugger; // SSSSS Show Group Testing
                if (createMode) {
                    //debugger; // SSSSS Show Group Testing
                    dispatch(addGroupShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                } else {
                    //debugger; // SSSSS Show Group Testing
                    dispatch(addGroupShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                    dispatch(addGroupTemplateShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                }

            } else {

                if (createMode) {
                    //debugger; // SSSSS Show Group Testing
                    dispatch(addQuestionShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                } else {
                    //debugger; // SSSSS Show Group Testing
                    dispatch(addQuestionShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                    dispatch(addQuestionTemplateShowGroupKeys(template, [...tempArray, ...groupTemplates[selectedShowGroupKey].showGroupKeys]));
                }

            }


            setSelectedShowGroupKey("");
        }

    }, [JSON.stringify(groupTemplates), selectedShowGroupKey, dispatch, createMode, groupTemplateMode, groupTemplates, template]);

    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  Answer Section Functions
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████


    const onChangeAnswerText = (event, fieldName) => {
        let answer = {...answerOption};
        answer[fieldName] = event.target.value;
        updateAnswerFunc(answer, index);
    };

    const updateAnswerFunc = (answer, idx) => {
        //debugger; // SSSSS Show Group Testing
        dispatch(updateAnswer(groupTemplateMode, answer, idx, questionDepth));
    };

    const validateAnswerOptions = (answerOpt, answerOptTemplates) => {
        let errorText = " ";
        let duplicateAnswersErrorText = "";

        if (answerOpt.optionText.length === 0) {
            errorText = "Answer text cannot be blank.";
        }

        for (let i = 0; i < answerOptTemplates.length; i++) {
            const answerOptionText = answerOptTemplates[i].optionText;
            for (let j = 0; j < answerOptTemplates.length; j++) {
                const compareTo = answerOptTemplates[j].optionText;
                if (answerOptionText === compareTo && i !== j) {
                    duplicateAnswersErrorText = "Duplicate answer names!";
                }
            }
        }

        if (duplicateAnswersErrorText !== "") {
            errorText = errorText === " " ? duplicateAnswersErrorText : errorText + ",  " + duplicateAnswersErrorText;
        }

        return errorText;
    };

    const onSelectChange = (event, fieldName, menuItemText, idx) => {
        let value = event.target.value;
        let tempMetadata = {...answerOption.metadata};

        switch(fieldName) {
            case "iconPosition":
                if (value === icon.POSITION_NONE) {
                    if (tempMetadata.hasOwnProperty(icon.ICON_POSITION)){
                        delete tempMetadata[icon.ICON_POSITION];
                    }
                    if (tempMetadata.hasOwnProperty(icon.ICON_TYPE)){
                        delete tempMetadata[icon.ICON_TYPE];
                    }
                    if (tempMetadata.hasOwnProperty(icon.ICON_COLOR)){
                        delete tempMetadata[icon.ICON_COLOR];
                    }
                    setIconPosition(menuItemText);
                }
                else {
                    tempMetadata[icon.ICON_POSITION] = (isLikertAnswer || displayAsLikert) ? icon.likertIcons[value].name : menuItemText;
                    setIconPosition(menuItemText);
                }
                break;
            case "iconImageValue":
                tempMetadata[icon.ICON_TYPE] = icon.types[value].text;
                break;
            case "iconColorValue":
                tempMetadata[icon.ICON_COLOR] = color.standard[value].hex;
                break;
            // no default
        }

        handleMetaChange(tempMetadata, idx);
    };

    const setIconColorObjFunc = (idx, iconColorObjParam) => {

        let tempMetadata = {...answerOption.metadata};
        tempMetadata[icon.ICON_COLOR_OBJ] = JSON.stringify(iconColorObjParam);

        switch(iconColorObjParam.colorType) {
            case "select":
                tempMetadata[icon.ICON_COLOR] = iconColorObjParam.color;
                break;
            case "hex":
                tempMetadata[icon.ICON_COLOR] = iconColorObjParam.colorEntry;
                break;
            case "rgb":
                tempMetadata[icon.ICON_COLOR] = iconColorObjParam.colorEntry;
                break;
            // no default
        }

        handleMetaChange(tempMetadata, idx);
    };

    const handleMetaChange = (metadata, idx) => {
        let updatedTemplate = {...answerOption};
        updatedTemplate.metadata = metadata;
        dispatch(updateAnswer(groupTemplateMode, updatedTemplate, idx, questionDepth));
    };


    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  Sections (Actions, Show Groups and Metadata) Toggle Open/Close
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████


    const onClickToggleSectionOpenClose = (event, fieldName) => {
        switch(fieldName) {
            case "sectionActionsOpen":
                setSectionActionsOpen(!sectionActionsOpen);
                break;
            case "sectionShowGroupsOpen":
                setSectionShowGroupsOpen(!sectionShowGroupsOpen);
                break;
            case "sectionMetadataOpen":
                setSectionMetadataOpen(!sectionMetadataOpen);
                break;
            // no default
        }
    };


    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  Actions Section Functions
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████

    const showSectionActions = (idx) => {
        return (
            <div style={{width: "100%"}}>
                <div style={{paddingLeft: "64px"}}>

                    {(questionDepth === 0) ?
                        <div style={{flexDirection: "row", alignItems: "center", width: "100%", paddingTop: "15px"}}>
                            <ArgoButtonHook
                                fileName="AnswerEditorDetail"
                                fieldName="createAction"
                                variant="contained"
                                label={"Create Action"}
                                width={160}
                                containedTextColor={'white'}
                                containedBgColor={Colors.blue[500]}
                                containedHoverTextColor={'#010203'}
                                containedHoverBgColor={Colors.blue[500]}
                                onClick={toggleIsThisAnExistingAction}
                            />
                        </div>
                        : ""}

                    <div>&nbsp;</div>

                    <ArgoTextFieldSelectHook
                        fileName="AnswerEditorDetails"
                        fieldName="selectedActionType"
                        index={idx}
                        label="Select action type"
                        value={selectedActionType}
                        onChange={onSelectChangeActionType}
                        useTextForValue={true}
                        menuItems={actionTypeList}
                    />

                    <div>&nbsp;</div>

                    <ArgoTextFieldSelectHook
                        fileName="AnswerEditorDetails"
                        fieldName="selectedActionValue"
                        index={idx}
                        label="Select action"
                        value={selectedActionTemplate.name}
                        menuItems={actionsListBySelectedActionType}
                        onChange={onSelectAction}
                        useTextForValue={false}
                        valueProperty={"id"}
                        textProperty={"name"}
                    />

                    <div>&nbsp;</div>

                    {getActions(idx)}
                </div>
            </div>
        );
    };

    const getActions = (idx) => {
        const actionTypes = actionTypeList;
        let selectedActions = {};

        actionTypes.forEach((type) => {selectedActions[type] = [];});

        let answerOpt = answerOptionTemplates[idx];

        answerOpt.importActionKeys.forEach((templateKey) => {
            if (!actionTemplateState[templateKey]) {
                dispatch(getActionTemplate(templateKey));
                return;
            }

            let type = (actionTemplateState[templateKey].type) ? actionTemplateState[templateKey].type : "other";
            if (selectedActions[type]) {
                selectedActions[type].push(actionTemplateState[templateKey]);
            }
            else {
                console.warn("action template type is missing");// eslint-disable-line
            }
        });

        return Object.keys(selectedActions).map((type) => {
                if (selectedActions[type].length > 0) {
                    return (
                        <div key={type + index} style={{ width: "100%", marginTop: "8px"}}>

                            <div key={type + "action_label_" + index} style={{textTransform: "capitalize"}}>{type}</div>

                            {selectedActions[type].map((action, actionIndex) => {
                                return (
                                    <div key={action.templateKey} id={"AnswerEditorDetails-container-div-" + type} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>

                                        <div style={{display: "flex", paddingLeft: "15px"}}>
                                            {action.name}
                                        </div>

                                        <div style={{display: "flex", marginLeft: "auto"}}>
                                            <ArgoIconButtonHook
                                                fileName="AnswerEditorDetails"
                                                fieldName={action.templateKey}
                                                onClick={removeAction}
                                                index={actionIndex}
                                                depth={questionDepth}
                                                icon={<RemoveCircleOutlineIcon/>}
                                            />
                                        </div>

                                    </div>
                                );
                            })}

                        </div>
                    );
                }
                return null;
            }
        );
    };


    const toggleIsThisAnExistingAction = () => {
        setIsThisAnExistingAction("1");
        parentSetStateCallback({showActionEditor: true, answerIndex: index});
    };


    const removeAction = (event, fieldName) => {
        let actionKey = fieldName;
        let answer = {...answerOption};
        answer.importActionKeys = answer.importActionKeys.filter((key) => {
            return key !== actionKey;
        });
        updateAnswerFunc(answer, index);
    };

    const onSelectChangeActionType = (event, fieldName, menuItemText) => {
        setSelectedActionType(menuItemText);
        buildActionListBySelectedActionType(actionTypeList, actionTemplateList, menuItemText);
    };

    const buildActionListBySelectedActionType = (actionTypes, actionTempList, actionType) => {
        let actionsListByType = [];
        if (actionTempList.length > 0) {
            for (let i = 0; i < actionTempList.length; i++) {
                if (actionTempList[i].type === actionType) {
                    actionsListByType.push(actionTempList[i]);
                }
            }
        }
        setActionsListBySelectedActionType(actionsListByType);
    };

    const onSelectAction = (event, fieldName, menuItemText, idx) => {
        const selectedActionObj = actionsListBySelectedActionType.find(template => template.id === event.target.value)
        let actions = [...answerOption.importActionKeys];

        dispatch(getActionTemplate(selectedActionObj.templateKey));
        if (actions.indexOf(selectedActionObj.templateKey) < 0) {
            actions.push(selectedActionObj.templateKey);
        }

        let answer = {
            ...answerOption,
            importActionKeys: actions
        };

        updateAnswerFunc(answer, idx);
    };

    const setMetadataErrorTextFunc = (errorText) => {
        setMetadataErrorTextLocal(errorText);
        if (setMetadataErrorTextProp) {
            setMetadataErrorTextProp(errorText);
        }
    };

    const loadActions = () => {
        let actionLoaded = true;
        answerOption && answerOption.importActionKeys.forEach((key) => {
            if (!actionTemplateState[key]) {
                actionLoaded = false;
                dispatch(getActionTemplate(key));
            }
        });
        return actionLoaded;
    };

    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  Section Show Groups Functions
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████


    const showSectionShowGroups = (idx) => {
        return (
            <div className="layout vertical" style={{width: "100%"}}>
                <div style={{paddingLeft: "64px", paddingTop: "20px"}}>
                    {(answerOption.importGroupKeys.length > 0) ? "" :
                        <div>
                            <ArgoSelectExistingHook
                                mode={TEMPLATE.TYPE.GROUP}
                                editorName="AnswerEditorDetails"
                                paddingRight="0px"
                                width={140}
                                onAddTemplate={addGroupToAnswer}
                                openEditorCallBack={toggleIsThisAnExistingGroup}
                                hideCreateButton={true}
                                createMode={createMode}
                                parentTemplate={template}
                            />
                        </div>

                    }
                    <div>&nbsp;</div>
                    {getGroups(idx)}
                    <div>&nbsp;</div>
                </div>
            </div>);
    };

    const getGroups = (idx) => {
        return answerOption.importGroupKeys.map((key) => {
            let group = groupTemplates[key];
            if (!group) {
                dispatch(getGroupTemplate(key));
                console.warn("Group missing", key); // eslint-disable-line
                return null;
            }

            return (
                <div key={key} id="AnswerEditorDetails-show-group-comntainer-div" style={{display: "flex", flexDirection: "row", alignItems: "center", width: "100%"}}>
                    <div id="AnswerEditorDetails-show-group-name-container-div" style={{display: "flex"}}>
                        {group.name}
                    </div>
                    <div id={"AnswerEditorDetails-remove-show-group-icon-button-container-div" + idx} style={{display: "flex", marginLeft: "auto"}}>
                        <ArgoIconButtonHook
                            fileName="AnswerEditorDetails"
                            fieldName={key}
                            onClick={onClickRemoveGroup}
                            icon={<RemoveCircleOutlineIcon/>}
                        />
                    </div>
                </div>
            );
        });
    };

    const toggleIsThisAnExistingGroup = () => {
        const parentEditorType = groupTemplateMode ? EDITOR_TYPES.GROUP : EDITOR_TYPES.QUESTION;
        const parentEditorState = groupTemplateMode ? groupEditorState : questionEditorState;
        dispatch(setShowGroup(
            false,
            index,
            createEditorOrigin(parentEditorType, parentEditorState?.instanceId, questionDepth)
        ));
        parentSetStateCallback({showGroupEditor: true, answerIndex: index});
    };

    const addGroupToAnswer = (chosenGroup, groupTemplates) => {
        //debugger; // SSSSS Show Group Testing
        let groups = [...answerOption.importGroupKeys];

        if (groups.indexOf(chosenGroup.templateKey) < 0) {
            groups.push(chosenGroup.templateKey);
        }

        let answer = {
            ...answerOption,
            importGroupKeys: groups
        };

        setSelectedShowGroupKey(chosenGroup.templateKey); // Set Show Group Key

        updateAnswerFunc(answer, index);
        setCurrentGroupTemplates(groupTemplates);
    };

    const onClickRemoveGroup = (event, fieldName) => {
        let groupKey = fieldName; // showGroupKey to be removed

        //let aaa = questionTemplate;
        //let bbb = answerOptionTemplates;

        //debugger; // SSSSS Show Group Testing
        let answer = {...answerOption};  // Answer to remove showGroupKey from
        answer.importGroupKeys = answer.importGroupKeys.filter((key) => {
            return key !== groupKey;
        });
        //debugger; // SSSSS Show Group Testing
        updateAnswerFunc(answer, index); // Remove group key from answer.importGroupKeys

        // Loop through all answers and get remaining showGroupKeys
        // Because the same group could be assigned to more then one answer
        let showGroupKeys = [];
        for (let i= 0; i < answerOptionTemplates.length; i++) {

            // We only allow 1 show group per answer, so this will work NOTE: Use optionText for check because create will NOT have and ID/Key
            // Skip the answer the show group is being removed from
            if (answerOptionTemplates[i].optionText !== answer.optionText) {

                let tempShowGroupKeyAssigned = answerOptionTemplates[i].importGroupKeys.length ? answerOptionTemplates[i].importGroupKeys[0] : null; // NOTE: we only allow 1 show group per answer

                // Don't add dups
                if (tempShowGroupKeyAssigned && !showGroupKeys.includes(tempShowGroupKeyAssigned)) {
                    showGroupKeys.push(tempShowGroupKeyAssigned);
                }
            }
        }

        if (groupTemplateMode) {

            // Set the show group keys to [] only if there are NO OTHER showgroup keys in any answer.  This is NOT a perfect solution
            if (showGroupKeys.length === 0) {
                if (createMode) {
                    dispatch(setGroupShowGroupKeys("", showGroupKeys));
                } else {
                    dispatch(setGroupShowGroupKeys("", showGroupKeys));
                    dispatch(setGroupTemplateShowGroupKeys(template, showGroupKeys));
                }
            }

        } else {

            // Set the show group keys to [] only if there are NO OTHER showgroup keys in any answer.  This is NOT a perfect solution
            if (showGroupKeys.length === 0) {
                if (createMode) {
                    dispatch(setQuestionEditorShowGroupKeys(questionTemplate, showGroupKeys));
                } else {
                    dispatch(setQuestionTemplateShowGroupKeys(questionTemplate, showGroupKeys));
                }
            }

        }

        let groupTemplates = {...currentGroupTemplates};
        delete groupTemplates[groupKey];
        setCurrentGroupTemplates(groupTemplates);

        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 2000);

    };

    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  Section Metadata Functions
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████

    const handleAnswerMetadataChange = (answerTemplate) => {
        let updatedAnswer = {...answerOption};
        updatedAnswer.metadata = answerTemplate.metadata;
        updateAnswerFunc(updatedAnswer, index);
    };

    // const disableIfStateOrAddressQuestionType = () => {
    //     if (questionTemplate === null) {
    //         return false;
    //     }
    //     let type = questionTemplate.questionType;
    //     return (type === questionTypes.STATE_ONLY || type === questionTypes.ADDRESS_FULL);
    // };
    //
    // const disableIfYesNoQuestionType = () => {
    //     if (questionTemplate === null) {
    //         return false;
    //     }
    //     let type = questionTemplate.questionType;
    //     return (type === questionTypes.YES_NO);
    // };

    const onResponsiveLabelChange = (event) => {
        let updatedAnswer = portalShared.cloneObj(answerOption);
        updatedAnswer.metadata[portalShared.USE_LIKERT_RESPONSIVE_LABEL] = event.target.value;
        updateAnswerFunc(updatedAnswer, index);
    };

    const onAnswerTextOverrideChange = (event) => {
        let updatedAnswer = portalShared.cloneObj(answerOption);
        updatedAnswer.metadata[portalShared.DISPLAY_DEF_ANSWER_TEXT_OVERRIDE] = event.target.value;
        updateAnswerFunc(updatedAnswer, index);
    };

    const renderIconPosition = (isLikertAnswerParam, displayAsLikertParam, iconPos, idx) => {
        if (isLikertAnswerParam || displayAsLikertParam) {
            let value = "0";
            for (let i = 0; i < icon.likertModesTitlesAndPositions.length; i++) {
                if (iconPos === icon.likertModesTitlesAndPositions.name) {
                    value = icon.likertModesTitlesAndPositions[i].value;
                }
            }

            return (
                (iconPos !== icon.ICON_NO) ?
                    <ArgoTextFieldSelectHook
                        fileName="AnswerEditorDetails"
                        fieldName="iconPosition"
                        index={idx}
                        label="Icon"
                        value={value}
                        onChange={onSelectChange}
                        width="100px"
                        disabled={true}
                        menuItems={icon.likertModesTitlesAndPositions}
                        paddingBottom={"5px"}
                    /> : ""
            );
        }
        // else {
        //     return (
        //         <ArgoTextFieldSelectHook
        //             fileName="AnswerEditorDetails"
        //             fieldName="iconPosition"
        //             index={idx}
        //             label="Position"
        //             value={iconPosition}
        //             onChange={onSelectChange}
        //             width="100px"
        //             menuItems={icon.positions}
        //             useTextForValue={true}
        //             paddingBottom={"5px"}
        //         />
        //     );
        // }
    };

    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████
    //  RENDER
    // -████████████████████████████████████████████████████████████████████████████████████████████████████████████████

    let iconAllowed = true;
    if (!isLikertAnswer) {
        switch (questionTemplate?.questionType) {
            case questionTypes.YES_NO:
            case questionTypes.RADIO:
                iconAllowed = true;
                break;
            default:
                iconAllowed = false;
        }
    }

    let iconInitObj = icon.initIconSelectEntries(answerOption.metadata, (isLikertAnswer || displayAsLikert));

    if (typeof iconInitObj.iconColorObj === "string") {
        iconInitObj.iconColorObj = JSON.parse(iconInitObj.iconColorObj);
    }

    return (
        answerOption ?
        <div>
            <div id={"AnswerEditorDetails-container-div-index-" + index} style={{width: "100%"}}>

                <div key={answerOption.templateKey + index}
                     id={"AnswerEditorDetails-answer-row-" + index + "-container-div"}
                     style={{display: "flex", flexDirection: "row", alignItems: "center", width: "100%"}}>

                    <div style={{display: "flex", alignItems: "center"}}>

                        <ArgoAutocompleteHook
                            fileName="AnswerEditorDetails"
                            fieldName="optionText"
                            index={index}
                            label={"Answer " + (index + 1)}
                            onChange={onChangeAnswerText}
                            value={answerOption.optionText}
                            maxLength="255"
                            multiline={true}
                            errorText={validateAnswerOptions(answerOption, answerOptionTemplates)}
                            width="650px"
                            menuItems={ALLOWED_TOKEN}
                        />

                        <div style={{width: "15px"}}>&nbsp;</div>

                        {!iconAllowed ? "" :
                            <div style={{display: "flex", alignItems: "center", paddingTop: "3px"}}>

                                <div style={{width: "20px"}}></div>

                                <div style={{display: "flex", alignItems: "center"}}>
                                    {renderIconPosition(displayAsLikert, isLikertAnswer, iconInitObj.iconPosition, index)}
                                </div>

                                <div style={{width: "20px"}}></div>

                                {(iconInitObj.iconPosition === icon.POSITION_NO || iconInitObj.iconPosition === icon.POSITION_NONE || iconInitObj.iconPosition === icon.ICON_NO) ?
                                    <div style={{width: "25%"}}></div>
                                    :
                                    <React.Fragment>
                                        <div style={{display: "flex", alignItems: "center"}}>
                                            <ArgoSelectWithRenderValueHook
                                                fileName="AnswerEditorDetails"
                                                fieldName="iconImageValue"
                                                index={index}
                                                label="Image"
                                                defaultValue={iconInitObj.iconImageValue}
                                                // disabled={iconInitObj.iconPosition === icon.POSITION_ICON}
                                                disabled={true}
                                                onChange={onSelectChange}
                                                width="200px"
                                                menuItems={icon.iconImagesMenuItems}
                                                paddingBottom={iconInitObj.iconImageValue === "2" ? "22px" : "9px"}
                                            />
                                        </div>

                                        <div style={{width: "20px"}}></div>

                                        {showCustomColor ?
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                paddingBottom: "5px"
                                            }}>
                                                <ArgoColorInputHook mode="title"
                                                                colorLabel={"Selected Icon Color"}
                                                                    propsFieldName={"iconColorObj"}
                                                                initToObj={iconInitObj.iconColorObj}
                                                                opacityFlag={true}
                                                                largeHexEntry={false}
                                                                setColor={setIconColorObjFunc.bind(null, index)}
                                                                index={index}
                                                                height={'17px'}
                                                                defaultColorIndex={portalShared.COLOR_DEFAULT_BLUE_INDEX}
                                                                defaultColorEntry={portalShared.COLOR_DEFAULT_BLUE_HEX}
                                                />
                                            </div> : ""
                                        }


                                    </React.Fragment>
                                }

                            </div>
                        }

                    </div>

                </div>

                {(isLikertAnswer || displayAsLikert || questionTemplate.questionType === "RADIO") ?
                    <div>
                        <ArgoTextFieldHook
                            fileName="AnswerEditorDetails"
                            fieldName="answerTextOverride"
                            index={index}
                            label={"Answer Override "  + (index + 1)}
                            value={answerOption.metadata[portalShared.DISPLAY_DEF_ANSWER_TEXT_OVERRIDE]}
                            maxLength={40}
                            onChange={onAnswerTextOverrideChange}
                            width="300px"
                            divContainerHeight="52px"
                        />

                        <div style={{width: "20px"}}>&nbsp;</div>
                    </div> : ""
                }

                {answerOption.metadata.hasOwnProperty(portalShared.USE_LIKERT_RESPONSIVE_LABEL) ?
                    <div>
                        <ArgoTextFieldHook
                            fileName="AnswerEditorDetails"
                            fieldName="responsiveLabel"
                            index={index}
                            label="Responsive Label"
                            value={answerOption.metadata[portalShared.USE_LIKERT_RESPONSIVE_LABEL]}
                            maxLength={40}
                            multiline={true}
                            onChange={onResponsiveLabelChange}
                            width="300px"
                            divContainerHeight="52px"
                        />

                        <div style={{width: "20px"}}>&nbsp;</div>
                    </div> : ""
                }


                <div id={"AnswerEditorDetails-action-showgroup-metadata-sections-container-div-index-" + index}>

                    <div id={"AnswerEditorDetails-action-container-div-index-" + index}>
                        <ArgoSectionOpenCloseHook
                            fileName="AnswerEditorDetails"
                            fieldName="sectionActionsOpen"
                            sectionTitle={"Actions: (" + answerOption.importActionKeys.length + ")"}
                            onClick={onClickToggleSectionOpenClose}
                            open={sectionActionsOpen}
                        />

                        {sectionActionsOpen ? showSectionActions(index) : <div></div>}
                    </div>

                    <div id={"AnswerEditorDetails-showgroups-container-div-index-" + index}>
                        <ArgoSectionOpenCloseHook
                            fileName="AnswerEditorDetails"
                            fieldName="sectionShowGroupsOpen"
                            sectionTitle={"Show Group: (" + (answerOption.importGroupKeys.length ? "Yes" : "No") + ")"}
                            onClick={onClickToggleSectionOpenClose}
                            open={sectionShowGroupsOpen}
                        />

                        {sectionShowGroupsOpen ? showSectionShowGroups(index) : <div></div>}
                    </div>

                    <div id={"AnswerEditorDetails-metadata-container-div-index-" + index}>
                        <ArgoMetadataEditorHook
                            entityType={metadataTemplateTypes.AnswerTemplate}
                            template={answerOption}
                            depth={questionDepth}
                            onChangeCallback={handleAnswerMetadataChange}
                            metadata={answerOption.metadata}
                            errorText={metadataErrorText}
                            setMetadataErrorText={setMetadataErrorTextFunc}
                            hidden={true}
                        />
                    </div>
                </div>

            </div>

        </div> : ""
    );
}

AnswerEditorDetails.defaultProps = {
    isLikertAnswer: false,
    showCustomColor: true,
    groupTemplateMode: false
};

AnswerEditorDetails.propTypes = {
    index: PropTypes.number,
    answerOption: PropTypes.object,
    questionDepth: PropTypes.number,
    parentSetStateCallback: PropTypes.func,
    answerEditorSetStateCallback: PropTypes.func,
    groupTemplateMode: PropTypes.bool,
    isLikertAnswer: PropTypes.bool,
    displayAsLikert: PropTypes.bool,
    showCustomColor: PropTypes.bool,
    setMetadataErrorText: PropTypes.func,
    templateKey: PropTypes.string,
    hasAnswers: PropTypes.bool,
    template: PropTypes.object,
    answerOptionTemplates: PropTypes.array
};

export default AnswerEditorDetails;
